
import {
  PlayerObject
} from "@models/UpsertableBase";
import { 
  CreatureInstance 
} from "@dndModels";
import { DataType } from "@dndModels/Types";

/**
 * This is for holding actual instances of an organization.
 * It can be associated with campaigns 
 * (campaigns can also have multiple organization instances),
 * and characters in an associated campaign can also be made to be members
 * of the organization instance, and can be given titles in it.  
 * Additionally, creature instances can be added to an org instance.
 * When they are, they are given a title.  
 * Some titles are NPC only.
 * Need to have way to mark Characters as NPCs, 
 * and then they can get those titles too.
 * Level is used for determining the level used for the titles on pcs and npcs.
 * 
 */
export class OrgInstance extends PlayerObject {
  data_type: DataType = "org_instance";
  org_id = "";
  campaign_ids: string[] = [];
  level = 1;
  creature_instances: CreatureInstance[] = [];
  description = "";

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.org_id = obj.org_id ? obj.org_id : "";
      this.campaign_ids = obj.campaign_ids ? obj.campaign_ids : [];
      this.level = obj.level ? obj.level : 1;
      this.creature_instances = obj.creature_instances ? obj.creature_instances : [];
      this.description = obj.description ? obj.description : "";
    }
  }

  toDBObj(): any {
    const from_super = super.toDBObj();
    return {
      ...from_super,
      org_id: this.org_id,
      campaign_ids: this.campaign_ids,
      level: this.level,
      creature_instances: this.creature_instances,
      description: this.description
    };
  }

  copy(copyMe: OrgInstance, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.org_id = copyMe.org_id;
    this.campaign_ids = copyMe.campaign_ids;
    this.level = copyMe.level;
    this.creature_instances = copyMe.creature_instances;
    this.description = copyMe.description;
  }

  clone(drop_ids = false): OrgInstance {
    const new_obj = new OrgInstance();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}